import React from "react";

/**
 * Marquee
 * ───────
 * Scrolling trust strip, modeled on the LP Express renderer's MidMarquee cream
 * variant. Driven entirely by the brand's own proof points (`items`) — when the
 * brand has none, the strip renders nothing rather than showing generic claims.
 */
export function Marquee({ items }: { items?: string[] }) {
  const clean = (items ?? []).map((s) => s.trim()).filter(Boolean);
  if (clean.length === 0) return null;
  const repeated = Array.from({ length: 6 }, () => clean).flat();
  return (
    <div className="relative bg-[#F4EDDD] text-[#3F5094] overflow-hidden" data-testid="lp-marquee">
      <div className="py-2.5 flex whitespace-nowrap animate-[marqueeLp_30s_linear_infinite]">
        {repeated.map((t, i) => (
          <span
            key={i}
            className="mx-6 text-xs font-black uppercase tracking-widest font-sans flex items-center gap-6"
          >
            {t}
            <span className="text-[var(--color-brand-coral)]">·</span>
          </span>
        ))}
      </div>
      <style>{`@keyframes marqueeLp { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </div>
  );
}
